// Il sopralluogo sul tablet: copia locale + vista calcolata dal motore offline. La stessa forma della vista del server
// (`field_view` in routers/field.py), cosi' le schermate non sanno se stanno lavorando in linea o no.
import { answeredList, evaluate } from "./fieldEngine";

const COMPANY_KEYS = ["business_name", "ateco_code", "employees_total"];
const present = (v) => (typeof v === "number" ? true : Array.isArray(v) ? v.length > 0 : Boolean(v && String(v).trim()));

export function emptyRecord(id, base) {
  return { id, company_id: null, title: "", company: {}, meta: {}, document_kinds: ["dvr"], task_codes: [], answers: {}, documents: {},
    equipment_units: {}, server: null, send_queued: false, problems: [], rev: 0, created_local: new Date().toISOString(), ...base };
}

// I documenti scelti aggiungono da soli le loro lavorazioni (PiMUS, piano di emergenza), come fa il server.
export function withRequiredTasks(catalog, pack, kinds, tasks) {
  const out = [...tasks];
  for (const c of catalog.document_catalog) {
    if (!kinds.includes(c.kind)) continue;
    for (const t of c.tasks || []) if (pack.tasks[t] && !out.includes(t)) out.push(t);
  }
  return out;
}

export function dataNeeded(catalog, rec) {
  const out = [];
  for (const c of catalog.document_catalog) {
    if (!(rec.document_kinds || []).includes(c.kind)) continue;
    const missing = c.fields.filter((f) => f.scope === "company" ? !present((rec.company || {})[f.key]) : !present((rec.meta || {})[f.key]))
      .map((f) => ({ type: f.scope, key: f.key, label: f.label }));
    if (missing.length) out.push({ kind: c.kind, label: c.label, missing });
  }
  return out;
}

export function buildView(pack, rec) {
  const catalog = pack.catalog;
  const survey = { task_codes: rec.task_codes, answers: rec.answers, documents: rec.documents, equipment_units: rec.equipment_units, smart: true };
  const ev = evaluate(pack, survey);
  const serverState = (rec.server && rec.server.state) || "da_compilare";
  const workable = serverState === "da_compilare" || serverState === "da_completare";
  const queued = !!rec.send_queued;
  const state = queued && workable ? "in_coda" : serverState;
  const editable = workable && !queued;
  const docs = ev.documents.map((d) => ({ key: d.key, name: d.name, category: d.category, subject: d.subject, status: d.status,
    blocking: d.blocking_if_missing, expiration_required: d.expiration_required, expires_on: d.expires_on, days_to_expiry: d.days_to_expiry }));
  const company = rec.company || {};
  return {
    survey: { id: rec.id, company_id: rec.company_id, company_name: company.business_name || rec.title || "", title: rec.title || company.business_name || "",
      task_codes: rec.task_codes, document_kinds: rec.document_kinds,
      tasks: rec.task_codes.filter((t) => pack.tasks[t]).map((t) => ({ code: t, name: pack.tasks[t].name })),
      updated_at: rec.local_at, submitted: rec.server && rec.server.survey ? rec.server.survey.submitted : null },
    state, editable, local_only: !rec.server, change_request: rec.server ? rec.server.change_request : null,
    progress: ev.progress, next_questions: ev.next_questions, answered: answeredList(pack, survey, ev), open_items: ev.open_items,
    missing_evidence: ev.missing_evidence, documents: docs,
    missing_blocking_documents: docs.filter((d) => d.blocking && d.status !== "received"),
    equipment_instances: ev.equipment_instances, equipment_units: rec.equipment_units || {},
    company, meta: rec.meta || {}, data_needed: dataNeeded(catalog, rec),
    plans: (rec.server && rec.server.plans) || { code: null, address: null, needed: [], items: [] },
    can_send: editable && ev.next_questions.length === 0, problems: rec.problems || [], send_queued: queued,
  };
}

// Dati che il server chiede nel foglio "azienda" (stessi campi di CompanyIn).
export function companyPayload(c) {
  return { business_name: c.business_name || "", vat_number: c.vat_number || "", fiscal_code: c.fiscal_code || "",
    legal_address: c.legal_address || "", operating_address: c.operating_address || "", ateco_code: c.ateco_code || "",
    employees_total: c.employees_total === "" || c.employees_total === undefined ? null : c.employees_total, workers: c.workers || [] };
}

export { COMPANY_KEYS };
